import React, { Component } from "react";
import Checkbox from "material-ui/Checkbox";
import ActionThumbUp from "material-ui/svg-icons/action/thumb-up";
import AvAlbum from "material-ui/svg-icons/av/album";
import "./design.css";

class DesignComponent extends Component {
  render() {
    return (
      <div className="design">
        <p className="headline">Professional Development and Affiliations</p>
        <h4>Deep Learning Specialization</h4>
        <h5>2018 – 2019</h5>
        <p className="text-justify">deeplearning.ai</p>

        <div className="design-checkbox">
          <Checkbox
            checkedIcon={<ActionThumbUp />}
            uncheckedIcon={<AvAlbum />}
            iconStyle={{ fill: "#A80202" }}
            label="Neural Networks and Deep Learning"
          />
        </div>
        <div className="design-checkbox">
          <Checkbox
            checkedIcon={<ActionThumbUp />}
            uncheckedIcon={<AvAlbum />}
            iconStyle={{ fill: "#A80202" }}
            label="Improving Deep Neural Networks: Hyperparameter tuning, Regularization and Optimization"
          />
        </div>
        <div className="design-checkbox">
          <Checkbox
            checkedIcon={<ActionThumbUp />}
            uncheckedIcon={<AvAlbum />}
            iconStyle={{ fill: "#A80202" }}
            label="Structuring Machine Learning Projects"
          />
        </div>
        <div className="design-checkbox">
          <Checkbox
            checkedIcon={<ActionThumbUp />}
            uncheckedIcon={<AvAlbum />}
            iconStyle={{ fill: "#A80202" }}
            label="Convolutional Neural Networks"
          />
        </div>
        <div className="design-checkbox">
          <Checkbox
            checkedIcon={<ActionThumbUp />}
            uncheckedIcon={<AvAlbum />}
            iconStyle={{ fill: "#A80202" }}
            label="Sequence Models"
          />
        </div>
      </div>
    );
  }
}

export default DesignComponent;
